<style lang="scss" scoped>
  .chart-component {
    .chart-alert,
    .chart-loading {
      padding: 12px;
      text-align: center;
      h4 {
        font-size: 18px;
        line-height: 30px;
        font-weight: 300;
      }
    }

    .chart-loading {
      h4 {
        font-weight: 300;
      }
    }
  }
</style>

<template>
  <div
    class="chart-component"
    v-show="loading || fetched.data.total || alert"
  >
    <div
      class="chart-loading"
      v-show="loading"
    >
      <h4><i class="fa fa-circle-o-notch fa-spin" /></h4>
    </div>
    <div
      class="chart-alert"
      v-show="!show && !loading"
    >
      <h4>{{ __('Dados não disponíveis') }}</h4>
    </div>
    <div v-show="show">
      <Apex
        :type="type"
        :fetched="fetched"
        :stacked="stacked"
        :timeseries="timeseries"
        :height="height"
        :legend="legend"
        :format="format"
        :axis="axis"
        :ratio="ratio"
        :title="title"
        v-if="type !== 'avg' && type !== 'funnel' && type !== 'chartjs' && type !== 'total'"
      />
      <Funnel
        :fetched="fetched"
        :height="height"
        :width="width"
        v-if="type === 'funnel'"
      />
      <div
        class="widget widget-stats bg-white"
        v-if="type === 'total' || type === 'avg'"
        style="margin-bottom: 0"
      >
        <div class="stats-icon">
          <i class="fa fa-star" />
        </div>
        <div class="stats-info">
          <p>{{ total }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { currencyFormat } from '../../helpers/currencyFormat';
import { percentFormat } from '../../helpers/percentFormat';
import Apex from './Apex.vue';
import Funnel from './Funnel.vue';

export default {
  mounted () {
    this.fetch();

    this.$watch('source', () => this.fetch());
    this.$watch('range', () => this.fetch());
    this.$watch('imports', () => this.fetch());

    this.$watch('timeperiod', (timeperiod) => {
      switch (timeperiod) {
        case 'month':
          this.format = 'MM/YYYY';
          break;
        case 'year':
          this.format = 'YYYY';
          break;
        default:
          this.format = 'DD/MM';
          break;
      }

      this.fetch();
    });
  },

  props: ['height', 'width', 'type', 'range', 'source', 'timeseries', 'timeperiod', 'timeperiod_field', 'stacked', 'alert', 'legend', 'rotated', 'axis', 'ratio', 'title', 'imports', 'fakeData'],

  components: {
    Apex,
    Funnel,
  },

  data () {
    return {
      loading: false,
      format: 'DD/MM',
      fetched: {
        data: {
          total: 0,
        },
      },
    };
  },

  computed: {
    show () {
      return this.loading === false && this.fetched.data.total;
    },

    total () {
      let { total } = this.fetched.data;

      if (! total) {
        return '-';
      }

      if (this.type === 'avg') {
        total /= this.fetched.data.count;
      }

      if (this.fetched.options.chart.currency) {
        return currencyFormat(total);
      }

      if (this.fetched.options.chart.percentage) {
        return percentFormat(total, 1);
      }

      return total;
    },
  },

  methods: {
    fetch () {
      this.loading = true;

      const params = {
        range: this.range,
        timeseries: this.timeseries ? 1 : 0,
        timeperiod: this.timeperiod,
        timeperiod_field: this.timeperiod_field || 'created_at',
        imports: this.imports ? 1 : 0,
      };

      this.$http.get(`/report/source/${this.source}`, { params })
        .then(({ data: fetched }) => {
          this.fetched = fetched;

          this.$emit('input', fetched.data);
          this.$emit('empty', fetched.data.total === 0);
          this.$emit('fake', fetched.data.fake || false);

          // Overwrite if fakeData is present
          if (fetched.data.fake && this.fakeData) {
            fetched.data = this.fakeData;

            this.fetched = fetched;
          }

          this.loading = false;
        });
    },
  },
};
</script>
